import React from 'react'
import { Icon } from '@chakra-ui/icons'
import { Button } from '@chakra-ui/react'
import { Box, Link } from '@chakra-ui/react'
import { FiExternalLink } from 'react-icons/fi'

import {
    ChatMessageFieldsFragment,
    MessageMethod,
} from '~graphql/generated/graphql'

interface Props {
    message: ChatMessageFieldsFragment
}

/**
 * Ensures a URL is treated as an absolute external link by prepending a
 * protocol when one is missing. Without this, protocol-less URLs (e.g.
 * "www.trupanion.com") are interpreted as relative paths by the browser and
 * resolved against the current origin.
 */
function toAbsoluteUrl(url: string): string {
    if (/^[a-z][a-z\d+.-]*:\/\//i.test(url)) return url
    return `https://${url}`
}

export default function SystemMessageCTA({ message }: Props) {
    if (
        !message.cta_text ||
        !message.cta_url ||
        message.message_methods?.includes(MessageMethod.Email)
    )
        return null

    return (
        <Box>
            <Link
                href={toAbsoluteUrl(message.cta_url)}
                isExternal
                onClick={e => e.stopPropagation()}
            >
                <Button
                    mt={2}
                    size="sm"
                    colorScheme="brand"
                    variant="outline"
                    rightIcon={<Icon as={FiExternalLink} />}
                >
                    {message.cta_text}
                </Button>
            </Link>
        </Box>
    )
}
